var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"passfoot-box"},[_c('router-link',{staticClass:"iconbnt-item",attrs:{"to":{name:'comment', query: _vm.paramInfo}}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/icon/icon-pinglun.png")}})]),_vm._v(" "),_c('div',[_vm._v("评论")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2acec174","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Approval/ApprovalFoot/approvalPassFoot.vue
// module id = null
// module chunks = 